// extracted by mini-css-extract-plugin
module.exports = {"empty":"Title_empty__I6_3w"};